import { useMutation, useQuery } from '@tanstack/react-query';
import fetchWrapper from '@http/fetchWrapper';
import { api } from '@http/constants';
import type { I18nReleaseLockState } from '@eye-able/types';

export const useReleaseActions = () => {
  const lockStatusAction = useQuery({
    retry: false,
    queryKey: [api.i18nReleaseLock],
    queryFn: () =>
      fetchWrapper.get(api.i18nReleaseLock) as Promise<I18nReleaseLockState>,
    refetchInterval: () => 3000,
  });

  const lockReleaseAction = useMutation({
    retry: false,
    mutationFn: () =>
      fetchWrapper.post(
        api.i18nReleaseLock,
        {},
      ) as Promise<I18nReleaseLockState>,
  });

  const unlockReleaseAction = useMutation({
    retry: false,
    mutationFn: () =>
      fetchWrapper.post(
        api.i18nReleaseUnlock,
        {},
      ) as Promise<I18nReleaseLockState>,
  });

  const releaseAction = useMutation({
    retry: false,
    mutationFn: (version: string) =>
      fetchWrapper.post(api.i18nRelease, {
        version,
      }) as Promise<void>,
  });

  return {
    lockStatusAction,
    lockReleaseAction,
    unlockReleaseAction,
    releaseAction,
  };
};
